export default __webpack_public_path__ + "static/media/camera-man.ae8b2d28.svg";